var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcnVisible = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 8"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M5.953 4.806a1.39 1.39 0 1 0 0-2.78 1.39 1.39 0 0 0 0 2.78m3.959.808c-.48.46-1.033.84-1.636 1.122a5.6 5.6 0 0 1-4.646 0 6.1 6.1 0 0 1-1.636-1.122A7 7 0 0 1 .787 4.111a7 7 0 0 1 1.207-1.504A6.2 6.2 0 0 1 3.41 1.594a3.13 3.13 0 1 0 5.086 0c.517.27.994.611 1.416 1.014.469.444.875.95 1.207 1.503a7 7 0 0 1-1.207 1.504M5.888.982h.127a2.434 2.434 0 1 1-.127 0m5.94 2.973A7.4 7.4 0 0 0 10.41 2.12a6.33 6.33 0 0 0-8.912 0A7.4 7.4 0 0 0 .08 3.955L0 4.111l.078.155a7.4 7.4 0 0 0 1.417 1.835 6.33 6.33 0 0 0 8.913 0 7.4 7.4 0 0 0 1.417-1.835l.078-.155z",
  clipRule: "evenodd"
})));
export default SvgIcnVisible;